import {Component, Input} from '@angular/core';

@Component({
    selector: 'dekra-logo',
    templateUrl: './dekra-logo.component.html',
    styleUrls: ['./dekra-logo.component.scss'],
    standalone: false
})
export class DekraLogoComponent {

	@Input() currentLang;

	getTitleText() {
		return 'DEKRA';
	}
}
